var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCompassFilled = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.333l.234.004c3.574.124 6.433 3.06 6.433 6.663l-.004.234c-.124 3.574-3.06 6.433-6.663 6.433-3.682 0-6.667-2.985-6.667-6.667S4.318 1.333 8 1.333zm2.372 4.218c-.184-.146-.435-.186-.659-.098L6.907 6.587c-.167.067-.3.2-.367.366l-1.167 2.84c-.084.228-.038.483.12.667h.034c.123.13.294.204.473.207l.095-.002c.064-.006.126-.021.185-.045l2.807-1.133c.166-.068.299-.2.366-.367l1.167-2.84c.068-.235.001-.488-.173-.66zM8.8 7.193l-.473 1.16-1.127.454.473-1.16L8.8 7.193z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCompassFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/compassFilled.a5bddfeb.svg";
export { ForwardRef as ReactComponent };